import { getHtml } from "../apis/templateHtml";
import { getUserInformationCached } from "../modules/userManager/UserManager";
import { navigate } from "../router/router";
// setIntervalのIDを保持
let clockIntervalId = null;
/**
 * 現在の日時を取得する関数
 * @returns 日時文字列（例：2025年5月27日(木) 16:15）
 */
function getCurrentDateTime() {
    let nowTime = new Date();
    let nowYear = twoDigit(nowTime.getFullYear());
    let nowMonth = twoDigit(nowTime.getMonth() + 1); // 月は0ベース補正
    let nowDay = twoDigit(nowTime.getDate());
    let nowHour = twoDigit(nowTime.getHours());
    let nowMin = twoDigit(nowTime.getMinutes());
    let nowSec = twoDigit(nowTime.getSeconds());
    const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'];
    return nowYear + "年" + nowMonth + "月" + nowDay + "日(" + dayOfWeek[nowTime.getDay()] + ") " + nowHour + ":" + nowMin + ":" + nowSec;
}
/**
 * 0埋め2桁処理
 * @param num
 * @returns
 */
function twoDigit(num) {
    let ret;
    if (num < 10)
        ret = "0" + num;
    else
        ret = num;
    return ret;
}
/**
 * 時計描画処理
 */
function showClock() {
    const realTime = document.getElementById("realtime");
    if (realTime) {
        realTime.innerHTML = getCurrentDateTime();
    }
}
/**
 * ホームボタンのイベントリスナーを設定
 */
function setupHomeButton() {
    const homeButton = document.getElementById('homeButton');
    if (homeButton) {
        homeButton.addEventListener('click', (e) => {
            e.preventDefault();
            navigate('/');
        });
    }
}
export const initializeHeader = async (title = "建築設備進捗確認", showUserInfo = true) => {
    const contentsElement = document.getElementById('header');
    // header要素が存在しない場合はエラーログを出力して処理を中断
    if (!contentsElement) {
        console.error('Header element not found. DOM may not be ready yet.');
        return;
    }
    const contents = await getHtml("/parts/header.html");
    if (contents) {
        // タイトルを設定してHTMLを生成
        const headerTitle = contents.replace(/\{\{title\}\}/g, title);
        contentsElement.innerHTML = headerTitle;
    }
    // ホームボタンのイベントリスナーを設定
    setupHomeButton();
    // ユーザー情報を表示しない場合は、header-rightを非表示にして処理を終了
    if (!showUserInfo) {
        const headerRight = document.getElementById('header-right');
        if (headerRight) {
            headerRight.style.display = 'none';
        }
        return;
    }
    // ユーザー情報を動的に取得
    try {
        const userInfo = await getUserInformationCached();
        const username = userInfo?.[0]?.employee_name || "ユーザー"; // dataListの最初の要素からemployee_nameを取得
        const usernameElement = document.getElementById('username');
        if (usernameElement) {
            usernameElement.innerHTML = username;
        }
    }
    catch (error) {
        console.error('ユーザー情報の取得に失敗しました:', error);
        // エラー時はデフォルト値を表示
        const usernameElement = document.getElementById('username');
        if (usernameElement) {
            usernameElement.innerHTML = "ユーザー";
        }
    }
    // 現在の日時を表示
    showClock();
    // 既存のタイマーがあればクリア
    if (clockIntervalId !== null) {
        clearInterval(clockIntervalId);
    }
    // 1秒毎に更新
    clockIntervalId = setInterval(() => {
        showClock();
    }, 1000);
};
/**
 * 既存のユーザー情報を使用してヘッダーを初期化する
 * @param userInfo ユーザー情報
 * @param title ヘッダータイトル
 * @param showUserInfo ユーザ情報表示の有無
 */
export const initializeHeaderWithUserInfo = async (userInfo, title = "建築設備進捗確認", showUserInfo = true) => {
    const contentsElement = document.getElementById('header');
    // header要素が存在しない場合はエラーログを出力して処理を中断
    if (!contentsElement) {
        console.error('Header element not found. DOM may not be ready yet.');
        return;
    }
    const contents = await getHtml("/parts/header.html");
    if (contents) {
        // タイトルを設定してHTMLを生成
        const headerTitle = contents.replace(/\{\{title\}\}/g, title);
        contentsElement.innerHTML = headerTitle;
    }
    // ホームボタンのイベントリスナーを設定
    setupHomeButton();
    // ユーザー情報を表示しない場合は、header-rightを非表示にして処理を終了
    if (!showUserInfo) {
        const headerRight = document.getElementById('header-right');
        if (headerRight) {
            headerRight.style.display = 'none';
        }
        return;
    }
    // 既存のユーザー情報を使用
    try {
        const username = userInfo?.[0]?.employee_name || "ユーザー"; // dataListの最初の要素からemployee_nameを取得
        const usernameElement = document.getElementById('username');
        if (usernameElement) {
            usernameElement.innerHTML = username;
        }
    }
    catch (error) {
        console.error('ユーザー情報の設定に失敗しました:', error);
        // エラー時はデフォルト値を表示
        const usernameElement = document.getElementById('username');
        if (usernameElement) {
            usernameElement.innerHTML = "ユーザー";
        }
    }
    // 現在の日時を表示
    showClock();
    // 既存のタイマーがあればクリア
    if (clockIntervalId !== null) {
        clearInterval(clockIntervalId);
    }
    // 1秒毎に更新
    clockIntervalId = setInterval(() => {
        showClock();
    }, 1000);
};
